import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { AppWrapper } from "./components/common/PageMeta.tsx";
import { ThemeProvider } from "./context/ThemeContext.tsx";
import { AuthProvider } from "./context/AuthContext.tsx";
import { ConfigProvider } from "./context/ConfigContext.tsx";
import { ToastProvider } from "./context/ToastContext.tsx";
import { ConfirmProvider } from "./context/ConfirmContext.tsx";
import { MensagensProvider } from "./context/MensagensContext.tsx";
import { GeolocalizacaoProvider } from "./context/GeolocalizacaoContext.tsx";
import { CandidatoProvider } from "./context/CandidatoContext.tsx";
import ErrorBoundary from "./components/ErrorBoundary.jsx";

// Recarrega automaticamente a página se houver erro ao carregar chunks JS
// após um novo deploy (evita tela em branco / Failed to fetch dynamic module).
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  const reloadKey = "chunk_reload_timestamp";
  const lastReload = Number(sessionStorage.getItem(reloadKey) || 0);
  const now = Date.now();
  if (now - lastReload > 10000) {
    sessionStorage.setItem(reloadKey, String(now));
    window.location.reload();
  }
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <ConfigProvider>
        <ThemeProvider>
          <AppWrapper>
            <AuthProvider>
              <CandidatoProvider>
                <ToastProvider>
                <ConfirmProvider>
                  <MensagensProvider>
                    <GeolocalizacaoProvider>
                      <App />
                    </GeolocalizacaoProvider>
                  </MensagensProvider>
                </ConfirmProvider>
              </ToastProvider>
              </CandidatoProvider>
            </AuthProvider>
          </AppWrapper>
        </ThemeProvider>
      </ConfigProvider>
    </ErrorBoundary>
  </StrictMode>,
);
